import { Section, useConfig } from '@seek/libs-shared';
import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Button, Card, Stack, Text } from 'braid-design-system';
import { useNavigate, useParams } from 'react-router';
import { CompanyProfilesPage, ROOT_PATH } from '../../../../paths';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface SalariesSearchSectionProps {
  model: Pick<SalariesTabModel, 'companyName'>;
  isSalariesByRole?: boolean;
}

export const SalariesListingSection = ({
  model,
  isSalariesByRole = false,
}: SalariesSearchSectionProps) => {
  const { companyName } = model;

  const { t } = useTranslations(translations);
  const navigate = useNavigate();
  const { language } = useConfig();
  const params = useParams();
  const localize = useMelwaysLink();

  const MockedRoleId = 'software-engineer';

  const viewSalaryByRoleLink = localize({
    path: `/${ROOT_PATH}/${params.companySlug}/${CompanyProfilesPage.Salaries}/${MockedRoleId}`,
    language,
  });

  return (
    <Section
      mode={'view'}
      heading={
        isSalariesByRole
          ? t('More companyName salaries', { companyName })
          : t('Salary at companyName', { companyName })
      }
      padding={'none'}
    >
      <Card>
        <Stack space="small">
          <Button
            onClick={() => {
              void navigate(viewSalaryByRoleLink);
            }}
          >
            view salaries by role page
          </Button>
          <Text>Placeholder to show the role listing</Text>
        </Stack>
      </Card>
    </Section>
  );
};
